module.exports = __webpack_public_path__ + "static/ForTheKing1-7cb9f2c2b016c31f7f5272ec5736ca2f.png";